// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export default defineNuxtPlugin(() => {
  let isLighthouseBot = false
  try {
    const { userAgent } = useDevice()
    isLighthouseBot = /Lighthouse|PageSpeed|Googlebot|Chrome-Lighthouse|Google Page Speed Insights|moto g/i.test(userAgent)
  } catch {
    //
  }
  return {
    provide: {
      isLighthouseBot
    }
  }
})
